// A URL da API vem de REACT_APP_API_URL, injetada no momento do build
// (Dockerfile --build-arg / GitHub Actions). O Create React App resolve essas
// variáveis em build time, então não adianta defini-la no ambiente do container.
//
// Em desenvolvimento, aponte para o backend local criando um `.env.local` na
// raiz do frontend (o arquivo já está no .gitignore):
//
//     REACT_APP_API_URL=http://localhost:5000/api
//
// O padrão é produção de propósito: um build sem a variável definida nunca deve
// gerar um bundle apontando para localhost.
const API_BASE_URL =
    process.env.REACT_APP_API_URL || "https://api-dafmc.elshadaysystems.com.br/api";

// Base para download de arquivos (uploads), que ficam fora do prefixo /api.
const API_BASE_URL_ARQUIVOS = API_BASE_URL.replace(/\/api\/?$/, "");

/**
 * Monta a URL de um arquivo servido em /uploads.
 *
 * /uploads deixou de ser público: a rota exige autenticação e confere se o
 * arquivo pertence à empresa de quem pede. Como <img src>, <iframe src> e
 * <a href download> não têm como enviar o cabeçalho Authorization, o backend
 * também aceita o token na query string — é por isso que ele viaja aqui.
 *
 * Use somente para caminhos de /uploads; para chamadas de API o token continua
 * indo no cabeçalho, pelo interceptor do axios.
 */
const urlArquivo = (caminho) => {
    if (!caminho) return "";

    const token = localStorage.getItem("token");
    if (!token) return `${API_BASE_URL_ARQUIVOS}${caminho}`;

    // O caminho pode já trazer query string própria.
    const separador = String(caminho).includes("?") ? "&" : "?";
    return `${API_BASE_URL_ARQUIVOS}${caminho}${separador}token=${encodeURIComponent(token)}`;
};

const config = {
    API_BASE_URL,
    API_BASE_URL_ARQUIVOS,
    urlArquivo,
};

export default config;
